import { ObjectValues } from 'types';
import { User } from './User';

export const REACTION_TYPE = {
  THUMBS_UP: 'thumbsUp',
  THUMBS_DOWN: 'thumbsDown',
  QUESTION_MARK: 'questionMark',
} as const;

export type ReactionType = ObjectValues<typeof REACTION_TYPE>;

export type ReactionUsers = {
  thumbsUp: Partial<User>[];
  thumbsDown: Partial<User>[];
  questionMark: Partial<User>[];
};
